// extracted by mini-css-extract-plugin
export var p = "subheading-module--p--b5186";